export default __webpack_public_path__ + "static/media/placeholder_image.00f542fc.png";